import { userRoleLevels, userRoles } from 'features/UserPermissions'

import {
  GET_BILLING_CONTACTS_FAILED,
  GET_BILLING_CONTACTS_STARTED,
  GET_BILLING_CONTACTS_SUCCESS,
  GET_INVOICES_LIST_FAILED,
  GET_INVOICES_LIST_STARTED,
  GET_INVOICES_LIST_SUCCESS,
  GET_PAYMENT_LIST_FAILED,
  GET_PAYMENT_LIST_STARTED,
  GET_PAYMENT_LIST_SUCCESS,
  INTERNAL_ADMIN_LOGGED_IN,
  SEND_INVOICE_FAILED,
  SEND_INVOICE_STARTED,
  SEND_INVOICE_SUCCESS,
  UPDATE_GROUP_BILLING_PERMISSION,
  UPDATE_GROUP_VIEW_PREFERENCE
} from '../actions/actionTypes'

export default function billing(
  state = {
    isLoading: false,
    isSendingInvoice: false,
    currentBalance: 0,
    invoices: [],
    payments: [],
    totalDue: null,
    activeBalance: 0,
    error: null,
    merchantName: '',
    didInvoiceSentSuccesfully: null,
    billingContacts: [],
    isGettingBillingContacts: false,
    hasGroupViewAccess: null,
    isGroupView: false
  },
  action
) {
  switch (action.type) {
    case 'SAVE_POSTED_SUBSIDIARY': {
      const isBillingAdmin =
        action.payload.roles.find(r => r.role === userRoles.Billing).accessLevel ===
        userRoleLevels.HasGroupLevelPermission

      return {
        ...state,
        hasGroupViewAccess: isBillingAdmin,
        isGroupView: isBillingAdmin
      }
    }

    case GET_INVOICES_LIST_STARTED:
      return {
        ...state,
        isGettingInvoices: true,
        didInvoiceSentSuccesfully: false
      }

    case GET_INVOICES_LIST_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isGettingInvoices: false,
        currentBalance: action.payload.currentBalance
      }

    case GET_INVOICES_LIST_FAILED:
      return {
        ...state,
        isGettingInvoices: false,
        error: action.payload
      }

    case GET_PAYMENT_LIST_STARTED:
      return {
        ...state,
        isGettingPayments: true
      }

    case GET_PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        payments: action.payload,
        isGettingPayments: false
      }

    case GET_PAYMENT_LIST_FAILED:
      return {
        ...state,
        error: action.payload,
        isGettingPayments: false
      }

    case SEND_INVOICE_STARTED:
      return {
        ...state,
        isSendingInvoice: true
      }

    case SEND_INVOICE_SUCCESS:
      return {
        ...state,
        isSendingInvoice: false,
        didInvoiceSentSuccesfully: true
      }

    case SEND_INVOICE_FAILED:
      return {
        ...state,
        isSendingInvoice: false,
        error: action.payload
      }

    case GET_BILLING_CONTACTS_STARTED:
      return {
        ...state,
        isGettingBillingContacts: true
      }

    case GET_BILLING_CONTACTS_SUCCESS:
      return {
        ...state,
        isGettingBillingContacts: false,
        billingContacts: action.payload
      }

    case GET_BILLING_CONTACTS_FAILED:
      return {
        ...state,
        isGettingBillingContacts: false,
        error: action.payload
      }

    case INTERNAL_ADMIN_LOGGED_IN:
      return {
        ...state,
        isGroupView: false
      }

    case UPDATE_GROUP_BILLING_PERMISSION:
      return {
        ...state,
        hasGroupViewAccess: action.payload
      }

    case UPDATE_GROUP_VIEW_PREFERENCE:
      return {
        ...state,
        isGroupView: action.payload
      }

    default:
      return state
  }
}
